/**
 * Money in and out of text inputs.
 *
 * Shared by every place that lets a price be typed for a single document, so
 * "646,60" and "1.234,56" are understood the same way everywhere.
 */

export const roundPrice = (value) => Math.round(value * 100) / 100;

export const formatCurrency = (value) =>
  new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(value || 0);

// Accepts what people actually type: "646,60", "1.234,56", "1,234.56", "646.6".
export const parsePriceInput = (raw) => {
  const cleaned = String(raw ?? "").replace(/[^0-9,.]/g, "");
  if (!cleaned) return null;

  const lastComma = cleaned.lastIndexOf(",");
  const lastDot = cleaned.lastIndexOf(".");
  let normalized = cleaned;
  if (lastComma > -1 && lastDot > -1) {
    normalized =
      lastComma > lastDot
        ? cleaned.replace(/\./g, "").replace(",", ".")
        : cleaned.replace(/,/g, "");
  } else if (lastComma > -1) {
    normalized = cleaned.replace(",", ".");
  }

  const value = Number.parseFloat(normalized);
  return Number.isFinite(value) && value >= 0 ? roundPrice(value) : null;
};

export const toPriceInputValue = (value) =>
  value === undefined || value === null ? "" : String(value).replace(".", ",");
